import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";

const state = {
  clients: null,
  clientSyncs: null,
  currentClient: null,
  currentClientProjects: null,
  currentClientTags: null,
  tagsPagination: null,
  currentClientCustomFields: null,
};

const getters = {
  clients_get_client_list: (state) => {
    return state.clients;
  },
  clients_get_client_syncs_list: (state) => {
    return state.clientSyncs;
  },
  clients_get_current_client: (state) => {
    return state.currentClient;
  },
  clients_get_current_client_projects: (state) => {
    return state.currentClientProjects;
  },
  clients_get_current_client_tags: (state) => {
    return state.currentClientTags;
  },
  clients_get_tags_pagination: (state) => {
    return state.tagsPagination;
  },
  clients_get_current_client_custom_fields: (state) => {
    return state.currentClientCustomFields;
  },
};

const mutations = {
  CLIENTS_SET_CLIENT_LIST(state, clients) {
    state.clients = clients;
  },
  CLIENTS_SET_CLIENT_SYNCS_LIST(state, clientSyncs) {
    state.clientSyncs = clientSyncs;
  },
  CLIENTS_SET_CURRENT_CLIENT(state, client) {
    state.currentClient = client;
  },
  CLIENTS_SET_CURRENT_CLIENT_PROJECTS(state, projects) {
    state.currentClientProjects = projects;
  },
  CLIENTS_SET_CURRENT_CLIENT_TAGS(state, tags) {
    state.currentClientTags = tags;
  },
  CLIENTS_SET_TAGS_PAGINATION(state, pagination) {
    state.tagsPagination = pagination;
  },
  CLIENTS_SET_CURRENT_CLIENT_CUSTOM_FIELDS(state, customFields) {
    state.currentClientCustomFields = customFields;
  },
};

const actions = {
  getClientList({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "updated_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        external_id: payload.params.external_id ? payload.params.external_id : "",
        custom: payload.params.custom ? payload.params.custom : "",
        email: payload.params.email ? payload.params.email : "",
        is_mine:
          typeof payload.params.is_mine !== "undefined" && payload.params.is_mine !== null
            ? payload.params.is_mine
            : "",
        with_tag:
          typeof payload.params.with_tag !== "undefined" && payload.params.with_tag !== null
            ? payload.params.with_tag
            : "",
        without_tag:
          typeof payload.params.without_tag !== "undefined" && payload.params.without_tag !== null
            ? payload.params.without_tag
            : "",
        with_custom:
          typeof payload.params.with_custom !== "undefined" && payload.params.with_custom !== null
            ? payload.params.with_custom
            : "",
        without_custom:
          typeof payload.params.without_custom !== "undefined" && payload.params.without_custom !== null
            ? payload.params.without_custom
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsGet(params)
            .then((res) => {
              console.log("teamClientsGet", res);
              commit("CLIENTS_SET_CLIENT_LIST", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "clients",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  search: params.search,
                  filter: {
                    is_mine: params.is_mine,
                    with_tag: params.with_tag,
                    without_tag: params.without_tag,
                  },
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getClient({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientGet(params)
            .then((res) => {
              console.log("teamClientsClientGet", res);
              commit("CLIENTS_SET_CURRENT_CLIENT", res.data.data);
              commit("CLIENTS_SET_CURRENT_CLIENT_CUSTOM_FIELDS", res.data.meta.custom);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { name: "client" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createClient({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {})
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsPost(params, payload.data)
            .then((res) => {
              console.log("teamClientsPost", res);
              if (payload.tags) {
                payload.params = { client: res.data.data.uid };
                payload.data = payload.tags;
                dispatch("editClientTags", payload).then(() => {
                  console.log("TAGS END");
                  resolve(res.data.data);
                });
              } else {
                if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
                resolve(res.data.data);
              }
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editClient({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientPut(params, payload.data)
            .then((res) => {
              console.log("teamClientsClientPut", res.data.data);
              commit("CLIENTS_SET_CURRENT_CLIENT", res.data.data);
              if (payload.tags) {
                payload.data = payload.tags;
                dispatch("editClientTags", payload).then(() => {
                  console.log("TAGS END");
                  resolve(res.data.data);
                });
              } else {
                if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
                resolve(res.data.data);
              }
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { name: "client" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getClientProjects({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        client: payload.client,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "last_active_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        external_id: payload.params.external_id ? payload.params.external_id : "",
        custom: payload.params.custom ? payload.params.custom : "",
        is_posted:
          typeof payload.params.is_posted !== "undefined" && payload.params.is_posted !== null
            ? payload.params.is_posted
            : "",
        is_visited:
          typeof payload.params.is_visited !== "undefined" && payload.params.is_visited !== null
            ? payload.params.is_visited
            : "",
        is_mine:
          typeof payload.params.is_mine !== "undefined" && payload.params.is_mine !== null
            ? payload.params.is_mine
            : "",
        is_private:
          typeof payload.params.is_private !== "undefined" && payload.params.is_private !== null
            ? payload.params.is_private
            : "",
        is_archived:
          typeof payload.params.is_archived !== "undefined" && payload.params.is_archived !== null
            ? payload.params.is_archived
            : "",
        has_uploads:
          typeof payload.params.has_uploads !== "undefined" && payload.params.has_uploads !== null
            ? payload.params.has_uploads
            : "",
        has_downloads:
          typeof payload.params.has_downloads !== "undefined" && payload.params.has_downloads !== null
            ? payload.params.has_downloads
            : "",
        has_file_signings:
          typeof payload.params.has_file_signings !== "undefined" && payload.params.has_file_signings !== null
            ? payload.params.has_file_signings
            : "",
        has_messages:
          typeof payload.params.has_messages !== "undefined" && payload.params.has_messages !== null
            ? payload.params.has_messages
            : "",
        has_file_previews:
          typeof payload.params.has_file_previews !== "undefined" && payload.params.has_file_previews !== null
            ? payload.params.has_file_previews
            : "",
        with_status:
          typeof payload.params.with_status !== "undefined" && payload.params.with_status !== null
            ? payload.params.with_status
            : "",
        without_status:
          typeof payload.params.without_status !== "undefined" && payload.params.without_status !== null
            ? payload.params.without_status
            : "",
        with_template:
          typeof payload.params.with_template !== "undefined" && payload.params.with_template !== null
            ? payload.params.with_template
            : "",
        without_template:
          typeof payload.params.without_template !== "undefined" && payload.params.without_template !== null
            ? payload.params.without_template
            : "",
        with_user:
          typeof payload.params.with_user !== "undefined" && payload.params.with_user !== null
            ? payload.params.with_user
            : "",
        without_user:
          typeof payload.params.without_user !== "undefined" && payload.params.without_user !== null
            ? payload.params.without_user
            : "",
        with_contact:
          typeof payload.params.with_contact !== "undefined" && payload.params.with_contact !== null
            ? payload.params.with_contact
            : "",
        without_contact:
          typeof payload.params.without_contact !== "undefined" && payload.params.without_contact !== null
            ? payload.params.without_contact
            : "",
        with_tag:
          typeof payload.params.with_tag !== "undefined" && payload.params.with_tag !== null
            ? payload.params.with_tag
            : "",
        without_tag:
          typeof payload.params.without_tag !== "undefined" && payload.params.without_tag !== null
            ? payload.params.without_tag
            : "",
        with_pageviewed:
          typeof payload.params.with_pageviewed !== "undefined" && payload.params.with_pageviewed !== null
            ? payload.params.with_pageviewed
            : "",
        without_pageviewed:
          typeof payload.params.without_pageviewed !== "undefined" && payload.params.without_pageviewed !== null
            ? payload.params.without_pageviewed
            : "",
        with_custom:
          typeof payload.params.with_custom !== "undefined" && payload.params.with_custom !== null
            ? payload.params.with_custom
            : "",
        without_custom:
          typeof payload.params.without_custom !== "undefined" && payload.params.without_custom !== null
            ? payload.params.without_custom
            : "",
        time_col:
          typeof payload.params.time_col !== "undefined" && payload.params.time_col !== null
            ? payload.params.time_col
            : "",
        time_relative:
          typeof payload.params.time_relative !== "undefined" && payload.params.time_relative !== null
            ? payload.params.time_relative
            : "",
        time_from:
          typeof payload.params.time_from !== "undefined" && payload.params.time_from !== null
            ? payload.params.time_from
            : "",
        time_to:
          typeof payload.params.time_to !== "undefined" && payload.params.time_to !== null
            ? payload.params.time_to
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientProjectsGet(params)
            .then((res) => {
              console.log("teamClientsClientProjectsGet", res.data.data);
              commit("CLIENTS_SET_CURRENT_CLIENT_PROJECTS", res.data.data);
              commit("PROJECTS_SET_PROJECTS_STATI", res.data.meta.status);
              let customFilters = [];
              let filterName = "";
              if (params.with_custom) {
                params.with_custom.forEach((val) => {
                  filterName = "with_custom_" + val.split(".")[0];
                  if (!customFilters[filterName]) customFilters[filterName] = [];
                  customFilters[filterName].push(val.split(".")[1]);
                });
              }
              if (params.without_custom) {
                params.without_custom.forEach((val) => {
                  filterName = "without_custom_" + val.split(".")[0];
                  if (!customFilters[filterName]) customFilters[filterName] = [];
                  customFilters[filterName].push(val.split(".")[1]);
                });
              }
              commit("GLOBAL_SET_LISTS_SETTINGS", {
                list: "clientProjects",
                pagination: {
                  page: res.data.meta.pagination.current_page,
                  perPage: res.data.meta.pagination.per_page,
                  lastPage: res.data.meta.pagination.last_page,
                  total: res.data.meta.pagination.total,
                },
                order: {
                  col: params.order_col,
                  dir: params.order_dir,
                },
                filter: {
                  is_posted: params.is_posted,
                  is_visited: params.is_visited,
                  is_private: params.is_private,
                  is_archived: params.is_archived,
                  is_mine: params.is_mine,
                  has_uploads: params.has_uploads,
                  has_downloads: params.has_downloads,
                  has_file_signings: params.has_file_signings,
                  has_messages: params.has_messages,
                  has_file_previews: params.has_file_previews,
                  with_status: params.with_status,
                  without_status: params.without_status,
                  with_template: params.with_template,
                  without_template: params.without_template,
                  with_contact: params.with_contact,
                  without_contact: params.without_contact,
                  with_tag: params.with_tag,
                  without_tag: params.without_tag,
                  with_user: params.with_user,
                  without_user: params.without_user,
                  time_col: params.time_col,
                  time_relative: params.time_relative === "custom" ? "custom" : params.time_relative,
                  time_from: params.time_from,
                  time_to: params.time_to,
                },
                customFilters,
              });
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getClientSyncsList({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "updated_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsyncsGet(params)
            .then((res) => {
              console.log("teamClientsyncsGet", res);
              commit("CLIENTS_SET_CLIENT_SYNCS_LIST", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "clientSyncs",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  syncClientList({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsyncsPost(params)
            .then((res) => {
              console.log("teamClientsyncsPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getClientTags({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        client: payload.client,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "name",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        name: payload.params.name ? payload.params.name : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientTagsGet(params)
            .then((res) => {
              console.log("teamClientsClientTagsGet", res.data.data);
              commit("CLIENTS_SET_CURRENT_CLIENT_TAGS", res.data.data);
              if (res.data.meta) commit("CLIENTS_SET_TAGS_PAGINATION", res.data.meta.pagination);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editClientTags({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientTagsPut(params, payload.tags)
            .then((res) => {
              console.log("teamClientsClientTagsPut", res.data.data);
              if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteClient({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientDelete(params)
            .then((res) => {
              console.log("teamClientsClientDelete", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
